import { FC, ReactNode } from "react";
import style from "./CustomSection.module.scss";
import classNames from "classnames";
export const CustomSection: FC<{ children: ReactNode; className?: string }> = ({
  children,
  className = "",
}) => {
  return (
    <div className={classNames(style.container, className)}>{children}</div>
  );
};
